<template>
  <div class="flex flex-col items-center gap-6 p-8">
    <div class="space-y-4">
      <IconCircleCheck class="mx-auto size-16 text-green" />

      <h1
        id="success-heading"
        class="heading-lg focus:ring-0"
        tabindex="-1"
        v-text="'Success'"
      />
    </div>

    <p
      class="body-md"
      v-text="'If an account with that email address exists, password reset instructions should be sent out. If you are having difficulty resetting your account, please call us at 877-462-9234 for assistance.'"
    />

    <a
      class="btn btn--outline w-full"
      href="/"
      v-text="'Return to Homepage'"
    />
  </div>
</template>

<script lang="ts" setup>
import { nextTick, onMounted } from 'vue'

import IconCircleCheck from '@js/components/icons/IconCircleCheck.vue'

defineOptions({
  name: 'ForgotPasswordMessage',
})

onMounted(async () => {
  await nextTick()

  document.getElementById('success-heading')?.focus()
})
</script>
